import { listSalesMethods } from '../thunks/sales-methods';
import { handleFulfilled, handlePending, handleRejected } from './utils';

export const salesMethodsReducers = (builder) => {
  // list property sales methods
  builder
    .addCase(listSalesMethods.fulfilled, (state, action) => handleFulfilled(state, 'salesMethods', action))
    .addCase(listSalesMethods.pending, (state) => handlePending(state, 'salesMethods'))
    .addCase(listSalesMethods.rejected, (state) => handleRejected(state, 'salesMethods'));
};
